import React, { useImperativeHandle, useEffect, useState, useMemo } from 'react';
import { message, Transfer } from 'antd';
import courseFormUtils from '../../pages/CourseEditPage/courseFormUtils';
import useSyncObjectRelationships from '../../gql/hooks/useSyncObjectRelationships';
import useGroups from '../../gql/hooks/useGroups';
import useLocales from '../../gql/hooks/useLocales'; 
import './styles.less';

const FormEmployeeLocales = ( { form, modifiedCallback, ref } ) => {
    const [ employeeLocaleIds, setEmployeeLocaleIds ] = useState( [] );
    const [ sync ] = useSyncObjectRelationships();
    const { groups, groupsLoading, groupsError } = useGroups();
    const { locales, getLocaleLabel } = useLocales();

    useImperativeHandle( ref, () => ( {
        reset() {
            reset();
        },
        isModified() {
            return form.getFieldValue( 'employeeLocaleIdsAreModified' );
        },
        async syncData() {
            const syncData = courseFormUtils.getEmployeeLocaleSyncValues( form );
            
            if ( syncData ) {
                try {
                    await sync( { variables: { input: syncData } } );
                    courseFormUtils.updateEmployeeLocaleValues( form, syncData.relatedResourceIds );
                    reset();
                    return true;
                } catch ( error ) { 
                    console.error( 'Error saving!', error );  
                    message.error( 'Error saving!' );  
                    return false;
                } 
            }
        }
    } ) );
     
    const reset = () => {
        form.setFieldsValue( { employeeLocaleIdsAreModified: false } ); 
        form.setFieldsValue( { employeeLocaleIdsModified: [] } ); 
        setEmployeeLocaleIds( form.getFieldValue( 'employeeLocaleIds' ) );
        modifiedCallback( false ); 
    };

    const listData = useMemo( () => { 
        if ( groups && locales ) {
            return groups.filter( i => {
                return i.attributes.find( a => a.name === 'locale' );
            } ).map( a => {
                return { ...a, name: getLocaleLabel( a.name ) };
            } );
        } else {
            return [];
        }
    }, [ groups, locales ] );

    useEffect( () => listData && setEmployeeLocaleIds( form.getFieldValue( 'employeeLocaleIds' ) ), 
        [ listData, setEmployeeLocaleIds ] );

    const handleChangeIds = ( values ) => {
        setEmployeeLocaleIds( values ); 

        if ( JSON.stringify( values ) !== JSON.stringify( form.getFieldValue( 'employeeLocaleIds' ) ) ) {
            form.setFieldsValue( { employeeLocaleIdsAreModified: true } ); 
            form.setFieldsValue( { employeeLocaleIdsModified: values } ); 
            modifiedCallback( true );
        } else {
            form.setFieldsValue( { employeeLocaleIdsAreModified: false } ); 
            form.setFieldsValue( { employeeLocaleIdsModified: [] } ); 
            modifiedCallback( false );
        }
    };

    return (
        <div className="form-item-employee-locales">
            { !groupsLoading && !groupsError &&
                <>
                    <h4 style={ { marginBottom: '8px' } }>Employee Locales</h4>
         
                    <Transfer
                        dataSource={ listData }
                        showSearch
                        titles={ [ 'Available', 'Selected' ] }
                        targetKeys={ employeeLocaleIds }
                        onChange={ handleChangeIds }
                        render={ i => i.name || <span className='italic'>No Name</span> }
                        filterOption={ ( input, option ) => 
                            option.name.toLowerCase().includes( input.toLowerCase() )
                        }
                    />
                </>
            }
        </div>
    );
};

export default FormEmployeeLocales;
